// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"SearchPageNavigation_tabsWrapper__kMQRV"};